import React, { ReactElement, useEffect, useState } from 'react';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

import { Sheet } from 'records/Sheet';
import { SheetVersion } from 'records/SheetVersion';
import { History } from 'history';

import ChevronLeft from 'components/Icons/ChevronLeft';
import { useLocation } from 'react-router-dom';
import HeaderPunchTab from './HeaderPunchTab';
import HeaderRFITab from './HeaderRFITab';

interface Props extends WithAppStoreProps {
  sheet: Sheet;
  history: History;
}

interface RouterWithState {
  from: string;
}

const ViewerHeader = (props: Props): ReactElement => {
  const [navigateBackTo, setNavigateBackTo] = useState<string>('');
  const { state } = useLocation<RouterWithState>() || '';

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const referringPage = state?.from || '';

    let navigateTo = 'drawings';
    if (search.has('markup')) {
      navigateTo = 'punchlist';
    } else if (referringPage === 'rfiList') {
      navigateTo = 'rfis';
    }

    setNavigateBackTo(navigateTo);
  }, []);

  const handleBackClick = (): void => {
    const { history, appState } = props;

    let nextURL = '';

    switch (navigateBackTo) {
      case 'drawings':
        nextURL = `/project/${appState.selectedProject}/drawings/published`;
        break;
      case 'punchlist':
        nextURL = `/project/${appState.selectedProject}/punches`;
        break;
      case 'rfis':
        nextURL = `/project/${appState.selectedProject}/rfis`;
        break;
      default:
    }

    history.push(nextURL);
  };

  const { sheet, appState } = props;
  const { rfis } = appState;

  const sheetversion = sheet.versions.last<SheetVersion>();

  return (
    <div className="hs3 w100 bb-1 row justify-between shrink-0">
      <div className="row items-center">
        <div
          className="flex-center"
          style={{ width: '56px', borderColor: '#ced1d1' }}
        >
          <div
            className="hrem-2 wrem-2 flex-center fill-primary cursor-pointer"
            onClick={handleBackClick}
          >
            <ChevronLeft width="12px" height="22px" />
          </div>
        </div>
        <div
          className="hrem-1p5 br-solid br-width-1"
          style={{ borderColor: '#ced1d1' }}
        />
        <div className="row font-size-4 color-gray-8 ml3 items-center">
          <div className="mr3 color-primary nowrap truncate">
            {sheetversion.sheetnumber}
          </div>
          <div className="light nowrap truncate">{sheetversion.sheettitle}</div>
        </div>
      </div>
      <div className="row justify-start">
        <HeaderPunchTab sheet={sheet} />
        <HeaderRFITab rfis={rfis.toList()} sheetversion={sheetversion} />
      </div>
    </div>
  );
};

export default withAppStore<Props>(ViewerHeader);
